/*=========================================================================================
  File Name: moduleInstructorActions.js
  Description: Instructor Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

  fetchDataListItemsByFilter({ commit }, search) {

    return new Promise((resolve, reject) => {
      axios.get("api/Instructor/GetAllByFilter?search=" + search)
        .then((response) => {
          commit('SET_Instructors', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  searchInstructor({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios.post("api/Instructor/searchInstructor", search)
        .then((response) => {
          commit('SET_Instructors', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItems({ commit }) {

    return new Promise((resolve, reject) => {
      axios.get("api/Instructor/GetAll")
        .then((response) => {
          commit('SET_Instructors', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItem({ commit }, item) {

    return new Promise((resolve, reject) => {

      axios.post("api/Instructor/AddInstructor", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructor?ID=" + item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetItemByID(context, itemid) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/GetInstructor?ID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllInstructorAssessment(context, itemid) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/GetAllInstructorAssessment?instructorID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllInstructorCourses(context, itemid) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/GetAllInstructorCourses?instructorID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllInstructorExams(context, itemid) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/GetAllInstructorExams?instructorID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetAllInstructorReview(context, itemid) {
    debugger;
    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/GetAllInstructorReview?instructorID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/Instructor/UpdateInstructor?ID=" + item.ID, item)
        .then((response) => {
          // commit('UPDATE_Instructor', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeCourse(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructorCourse?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeObtainCourse(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructorObtainCourse?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeContact(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructorContact?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeEducation(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructorEducation?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeLanguage(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructorLangauge?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeArea(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructorArea?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeSector(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructorIndustrySector?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeAttachment(context, ID) {

    return new Promise((resolve, reject) => {
      axios.delete("api/Instructor/DeleteInstructrAttachment?ID=" + ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  Registration(context, item) {

    return new Promise((resolve, reject) => {
      axios.post("/InstructorRegistration", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetLoginInstructor(context) {
    debugger
    return new Promise((resolve, reject) => {
      debugger
      axios.get("api/Instructor/GetLoginInstructor")
        .then((response) => {
          debugger ;
          resolve(response)
        })
        .catch((error) => {
          debugger ;
          reject(error)
        })
    })
  },
  GetAllInstructorExamsUnMarked(context) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/GetAllInstructorExamsUnMarked")
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getInstructorAdvertisementNotify({ commit }, context) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/getInstructorAdvertisementNotify")
        .then((response) => {
          commit('SET_Mails', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SubmitAllAdvertisementNotifyAsRead(context, ListOfAdvertisement) {
    debugger
    return new Promise((resolve, reject) => {
      axios.post("API/Customer/SubmitAllAdvertisementNotifyAsRead", ListOfAdvertisement)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SubmitAdvertisementNotifyAsRead(context, Advertisement) {
    debugger
    return new Promise((resolve, reject) => {
      axios.post("API/Customer/SubmitAdvertisementNotifyAsRead", Advertisement)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllAnnualPlanNotConfirmed(context) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/getAllAnnualPlanNotConfirmed")
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllCourseClassNotConfirmed(context) {

    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/getAllCourseClassNotConfirmed")
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SetAsNotNew(context, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("API/Instructor/SetAsNotNew?ID=" + itemid)
        .then((response) => {

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
